const accordionTitles = document.querySelectorAll('.accordion-item__title');

[].forEach.call(accordionTitles, (item) => {
    item.addEventListener('click', function () {
        const parent = this.parentElement;
        if (parent.classList.contains('accordion-item') === false) {
            return;
        }
        parent.classList.toggle('active');
    });
})